import { render, staticRenderFns } from "./AgentInfoPropsList.vue?vue&type=template&id=1e9b58fe&"
import script from "./AgentInfoPropsList.vue?vue&type=script&lang=ts&"
export * from "./AgentInfoPropsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
